import React, { Component } from 'react';

class FooterAbout extends Component {
  constructor(props) {
    super(props);
  }

  getFooterAboutHTML() {
    const items = this.props.data.items;
    let html = items.map((item, index) =>
      <li key={index}><a href={item.href}>{item.label}</a></li>
    );

    return (
      <ul>
        {html}
      </ul>
    );
  }

  render() {
    return (
      <div className="col col-xs-6 col-md-2">
        <h6>{this.props.data.title}</h6>
        { this.getFooterAboutHTML() }
      </div>
    )
  }
}

export default FooterAbout;